import { useMsal } from "@azure/msal-react";
import { ICommandBarItemProps } from "@fluentui/react";
import { RouterParams } from "App";
import { RootState } from "app/store";
import { AppDataSource } from "global/DataSources/AppDataSource";
import { MsalTokenSource } from "global/DataSources/MsalTokenSource";
import { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import BlueRelationshipContext from "../BlueRelationshipContext";
import CheckListBrowser from "./CheckListBrowser";
import { ICheckListProps } from "./ICheckListProps";
import { endSnapshotLoad, startSnapshotLoad } from "global/Reducer/statusSlice";
import { emitCustomEvent } from "global/Application";
import ConfirmationDialog from "../ConfirmationDialog";
import { loadCheckListAction } from "global/Application/dataActions";


const CheckList = (props: ICheckListProps) => {
    const { planId, } = useParams<RouterParams>();

    const dispatch = useDispatch();
    const { instance } = useMsal();
    const tokenSource = new MsalTokenSource(instance);
    const dataSource = new AppDataSource(tokenSource);

    const [hiddenSendNotification, setHiddenSendNotification] = useState(true);

    const state = useSelector((state: RootState) => state);

    const contextMenu = useMemo(() => {

        const items: ICommandBarItemProps[] = [];

        // Generate SBC Option
        items.push({
            key: 'refresh',
            text: 'Refresh',
            title: 'Refresh',
            iconProps: { iconName: 'Refresh' },
            onClick: (ev, item) => {
                dispatch(loadCheckListAction(dataSource));
            }
        });

        // Generate SBC Option
        items.push({
            key: 'notify',
            text: 'Send Notifications',
            title: 'Send Notifications',
            disabled: !state?.data?.checkList?.some(t => !!t.bcbs_emchecklist.bcbs_sendnotificationcode),
            iconProps: { iconName: 'Send' },
            onClick: (ev, item) => {

                // TODO make available only to following processes:
                (async () => {
                    try {
                        dispatch(startSnapshotLoad());
                        await dataSource.generateChecklistSendNotification(state.data.snapshot);
                        setHiddenSendNotification(false);
                    } catch (error) {
                        emitCustomEvent({
                            eventType: 'globalException',
                            details: error
                        });

                    } finally {
                        dispatch(endSnapshotLoad());
                    }
                })();

            }
        });

        return { items: items, key: 'checklist' };
    }, [state.data.snapshot, state?.data?.checkList]);


    function onRenderCheckListPlanBrowser() {
        if (planId)
            return <></>;

        return <CheckListBrowser />;
    }

    return <BlueRelationshipContext contextMenu={contextMenu} isChecklist={true}>
        <ConfirmationDialog
            title="Action Complete"
            hidden={hiddenSendNotification}
            message="A notification dispatch process has been initiated. Please be advised that there may be a delay before the process is executed."
            actions={[
                {
                    name: 'Close',
                    onClick: () => {
                        setHiddenSendNotification(true);
                    }
                }
            ]}
        />
        {onRenderCheckListPlanBrowser()}
    </BlueRelationshipContext>
}

export default CheckList;